module.exports = __webpack_public_path__ + "static/media/connect-your-store.514466e1.jpeg";